<nav class="flex h-full min-h-0 w-full flex-col overflow-hidden py-2">
  <!-- Só a lista rola: o rodapé com a versão fica sempre visível. -->
  <div
    [ngClass]="expanded() || isMobile ? 'px-4' : 'px-3'"
    class="scrollbar-thumb-rounded flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-300"
  >
    <!-- Compacta (#799): item de 32px — a mesma altura do `appButton size="xs"` e dos
         selects compactos dos padrões de UI. São ~15 itens em 5 grupos, e o menu
         precisa caber sem rolagem em tela baixa.
         Sem moldura, quem separa um grupo do outro é o ritmo: 16px ANTES do título (é ali
         que o olho lê o fim do bloco anterior), 2px entre o título e os itens que ele
         manda, e item colado em item. Se esses três valores se aproximarem, a barra vira
         uma lista comprida e o título parece pertencer ao grupo de cima. -->
    <ul class="flex flex-col gap-5">
      @for (group of menu(); track trackByGroup($index, group)) {
        <li class="flex flex-col justify-center gap-1">
          <!-- Group Header -->
          <div class="w-full px-1">
            @if (expanded() || isMobile) {
              <h3 class="text-[11px] font-semibold uppercase leading-4 tracking-wide text-content-secondary/60">
                {{ group.group }}
              </h3>
            }
            @if (!expanded() && !isMobile) {
              <!-- Colapsada: o nome do grupo não cabe; sobra um filete separando os blocos.
                   Ele ocupa o lugar do título e por isso não leva margem nenhuma: quem dá o
                   ritmo é o mesmo par de fora (`gap-4` acima, `gap-0.5` abaixo). Margem
                   própria aqui empata o ar dos dois lados e desfaz a separação. -->
              <div class="mx-1 border-t border-gray-200"></div>
            }
          </div>
          <!-- Menu Items -->
          <ul class="flex w-full flex-col items-center gap-0.5 text-sm">
            @for (item of group.items; track trackByItem($index, item)) {
              <li class="w-full">
                <div class="group relative w-full transition-all duration-300">
                  <a
                    cdkOverlayOrigin
                    #origemDica="cdkOverlayOrigin"
                    (mouseenter)="dica.set(item.label ?? null)"
                    (mouseleave)="dica.set(null)"
                    (click)="isMobile ? onMenuItemClick() : null"
                    [routerLink]="item.route"
                    [attr.aria-label]="item.label"
                    [ngClass]="[
                      expanded() || isMobile ? 'justify-start pr-2' : 'justify-center',
                      itemAtivo(item.route)
                        ? 'bg-color-brand/15 hover:bg-color-brand/20 font-semibold text-color-brand'
                        : 'text-content-secondary hover:bg-background-primary',
                    ]"
                    class="flex h-9 w-full cursor-pointer items-center rounded-lg font-normal hover:bg-background-primary"
                  >
                    <!-- `currentColor` vence a cor fixa da marca do ng-icons: cinza no repouso, cor
                         só no ativo. Com tudo vermelho, o ativo some no meio dos outros. -->
                    <app-icon
                      [name]="item.icon!"
                      class="flex h-8 w-8 flex-shrink-0 items-center justify-center"
                      size="1.35em"
                    />
                    <!-- Label -->
                    <span
                      [ngClass]="
                        expanded() || isMobile ? 'w-full flex-grow opacity-100' : 'invisible w-0 flex-none opacity-0'
                      "
                      class="overflow-hidden transition-all duration-300"
                    >
                      <span
                        [ngClass]="itemAtivo(item.route) ? 'font-semibold' : 'text-content-primary'"
                        class="block truncate focus:outline-none"
                      >
                        {{ item.label }}
                      </span>
                    </span>
                  </a>
                  <!-- Recolhida: o nome vira dica. Vai pelo CDK Overlay, como a dica de campo:
                       dentro da barra ela seria cortada pelo corte de conteúdo da lateral. -->
                  @if (!expanded() && !isMobile) {
                    <ng-template
                      cdkConnectedOverlay
                      [cdkConnectedOverlayOrigin]="origemDica"
                      [cdkConnectedOverlayOpen]="!!item.label && dica() === item.label"
                      [cdkConnectedOverlayPositions]="posicoesDica"
                      [cdkConnectedOverlayViewportMargin]="8"
                    >
                      <span
                        role="tooltip"
                        class="block rounded-md bg-content-primary px-2 py-1 text-xs text-white shadow-lg"
                      >
                        {{ item.label }}
                      </span>
                    </ng-template>
                  }
                  <!-- Submenu items if needed -->
                  @if (item.children && item.children.length > 0 && item.expanded && (expanded() || isMobile)) {
                    <ul class="ml-10 mt-0.5 w-full">
                      @for (child of item.children; track child) {
                        <li class="w-full">
                          <a
                            (click)="isMobile ? onMenuItemClick() : null"
                            [routerLink]="child.route"
                            [ngClass]="filhoAtivo(child.route, item.children) ? 'text-color-brand font-medium' : ''"
                            class="block w-full truncate rounded-md px-3 py-1.5 text-[13px] hover:bg-gray-100"
                          >
                            {{ child.label }}
                          </a>
                        </li>
                      }
                    </ul>
                  }
                </div>
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </div>

  <!-- Versão: sempre visível, mas discreta. Colapsada, só o número. -->
  <div
    [ngClass]="expanded() || isMobile ? 'mx-4' : 'mx-3'"
    class="mt-2 shrink-0 border-t border-gray-200 pt-2 text-center"
  >
    <span class="text-[11px] font-medium text-content-secondary/50">
      {{ expanded() || isMobile ? 'Versão ' + versao : versao }}
    </span>
  </div>
</nav>
